var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("Header"),
      _vm._v(" "),
      _c("div", { attrs: { id: "main" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-3", attrs: { id: "categories-list" } },
              [
                _c("h4", [_vm._v("Categorias")]),
                _vm._v(" "),
                _c(
                  "ul",
                  [
                    _c(
                      "li",
                      {
                        class: {
                          active:
                            !_vm.category &&
                            !_vm.selectedFeat &&
                            !_vm.selectedFav
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: { href: "" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                $event.preventDefault()
                                return _vm.selectCategory(null)
                              }
                            }
                          },
                          [_vm._v("Todos os Projetos")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isAuth && _vm.showFavorites
                      ? _c("li", { class: { active: _vm.selectedFav } }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.selectFavoritedProjects()
                                }
                              }
                            },
                            [_vm._v("Meus Favoritos")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isAuth
                      ? _c("li", { class: { active: _vm.selectedFeat } }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  $event.preventDefault()
                                  return _vm.selectFavoritedCategories()
                                }
                              }
                            },
                            [_vm._v("Destaques")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.categoriesList, function(c) {
                      return _c(
                        "li",
                        {
                          key: c.CategoryId,
                          class: {
                            active:
                              _vm.category &&
                              _vm.category.CategoryId === c.CategoryId
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.selectCategory(c.CategoryId)
                            }
                          }
                        },
                        [
                          _c("a", { attrs: { href: "" } }, [
                            _vm._v(_vm._s(c.name))
                          ])
                        ]
                      )
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("h4", { staticClass: "location-title" }, [
                  _vm._v("Localização")
                ]),
                _vm._v(" "),
                _c("form", { staticClass: "location-form" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "inputEmail4" } }, [
                      _vm._v("Cidade")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchCity,
                          expression: "searchCity"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        id: "inputCity",
                        placeholder: "Busque por uma cidade"
                      },
                      domProps: { value: _vm.searchCity },
                      on: {
                        keyup: function($event) {
                          return _vm.searchProjectByCity()
                        },
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.searchCity = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("h4", { staticClass: "onu-title" }, [
                  _vm._v("Objetivos da ONU")
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  { staticClass: "onu-form" },
                  [
                    _c(
                      "b-form-checkbox-group",
                      {
                        attrs: { id: "checkboxes2", name: "flavour2" },
                        on: { change: _vm.filterByODS },
                        model: {
                          value: _vm.ods,
                          callback: function($$v) {
                            _vm.ods = $$v
                          },
                          expression: "ods"
                        }
                      },
                      _vm._l(_vm.odsList, function(o) {
                        return _c(
                          "b-form-checkbox",
                          {
                            key: o.number,
                            staticClass: "mb-2",
                            attrs: { value: o.slug }
                          },
                          [_vm._v(_vm._s(o.title))]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-md-9", attrs: { id: "projects-list" } },
              [
                _c("div", { staticClass: "breadcrumb-list" }, [
                  _c("ul", [
                    _c("li", [_vm._v("CONHECER")]),
                    _vm._v(" "),
                    !_vm.category && !_vm.selectedFav && !_vm.selectedFeat
                      ? _c("li", { staticClass: "active" }, [
                          _vm._v("TODOS OS PROJETOS")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.category && !_vm.selectedFav && _vm.selectedFeat
                      ? _c("li", { staticClass: "active" }, [
                          _vm._v("PROJETOS DESTAQUES")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.category && _vm.selectedFav && !_vm.selectedFeat
                      ? _c("li", { staticClass: "active" }, [
                          _vm._v("PROJETOS FAVORITADOS")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.category
                      ? _c("li", { staticClass: "active" }, [
                          _vm._v(_vm._s(_vm.category.name.toUpperCase()))
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "category-cover" },
                  [
                    _vm.categoryImage
                      ? _c("v-lazy-image", {
                          attrs: {
                            src: _vm.categoryImage,
                            "src-placeholder": ""
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.category && !_vm.selectedFeat && !_vm.selectedFav
                      ? _c("div", { staticClass: "content" }, [
                          _c("h2", [_vm._v("Todas Organizações Sociais")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Emocione-se com a diversidade de boas ações esperando por você."
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.category && !_vm.selectedFav && _vm.selectedFeat
                      ? _c("div", { staticClass: "content" }, [
                          _c("h2", [_vm._v("Projetos Destaque")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Selecionamos alguns projetos baseados em suas preferências."
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.category && _vm.selectedFav && !_vm.selectedFeat
                      ? _c("div", { staticClass: "content" }, [
                          _c("h2", [_vm._v("Projetos Favoritados")]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "Aqui você encontrará a lista de todos os projetos que favoritou."
                            )
                          ])
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.category
                      ? _c("div", { staticClass: "content" }, [
                          _c("h2", [_vm._v(_vm._s(_vm.category.name))]),
                          _vm._v(" "),
                          _c("p", [_vm._v(_vm._s(_vm.category.description))])
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm.projectsList && _vm.projectsList.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "projects row",
                        attrs: { id: "listProjects" }
                      },
                      _vm._l(_vm.projectsList, function(p) {
                        return _c(
                          "div",
                          {
                            key: p.ProjectId,
                            staticClass: "col-md-6 col-sm-6 col-lg-4"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "item",
                                on: {
                                  click: function($event) {
                                    return _vm.openProject(p.slug)
                                  },
                                  contextmenu: function($event) {
                                    $event.preventDefault()
                                    return _vm.openProjectInNewTab(p.slug)
                                  }
                                }
                              },
                              [
                                _c("div", { staticClass: "image" }, [
                                  p.Info.image &&
                                  p.Info.image.length > 0 &&
                                  p.Info.image.search("via.placeholder.com") ==
                                    -1
                                    ? _c("img", {
                                        attrs: { src: p.Info.image }
                                      })
                                    : _c("img", {
                                        attrs: {
                                          src:
                                            "https://via.placeholder.com/500x500&text=Sem+Foto"
                                        }
                                      })
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "content" }, [
                                  _c("h5", [_vm._v(_vm._s(p.Info.title))]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "donations" }, [
                                    p.Donations
                                      ? _c("span", [
                                          _c("b", [
                                            _vm._v(
                                              _vm._s(_vm.getDonationsValue(p))
                                            )
                                          ]),
                                          _vm._v(
                                            " de " +
                                              _vm._s(p.Donations.length) +
                                              " doador(es)"
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v("Valores indisponíveis")
                                        ])
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "description" }, [
                                    _vm._v(
                                      "\n                    " +
                                        _vm._s(
                                          p.Info.shortDescription &&
                                            p.Info.shortDescription.length > 0
                                            ? p.Info.shortDescription
                                            : null
                                        ) +
                                        "\n                  "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tags" },
                                    _vm._l(p.Categories, function(cat) {
                                      return cat.name
                                        ? _c(
                                            "a",
                                            {
                                              key: cat.CategoryId,
                                              attrs: { href: "" }
                                            },
                                            [_vm._v(_vm._s(cat.name))]
                                          )
                                        : _vm._e()
                                    }),
                                    0
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.projectsList &&
                _vm.projectsList.length == 0 &&
                (!_vm.searchCity ||
                  (_vm.searchCity && _vm.searchCity.length == 0))
                  ? _c("div", { staticClass: "projects row not-found" }, [
                      _c("h4", [_vm._v("Nenhum projeto encontrado.")])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.projectsList &&
                _vm.projectsList.length == 0 &&
                _vm.searchCity &&
                _vm.searchCity.length > 0
                  ? _c("div", { staticClass: "projects row not-found" }, [
                      _c("h4", [
                        _vm._v(
                          "Não há projetos sociais disponíveis nesta cidade no momento."
                        )
                      ])
                    ])
                  : _vm._e()
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _vm.loading
        ? _c("Loading", { attrs: { message: _vm.loadingMessage } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "userDataModal",
          attrs: {
            "ok-only": true,
            size: "md",
            "ok-title": "Processar Doação",
            id: "userDataModal",
            title: "Informe um valor a ser doado"
          },
          on: { ok: _vm.submitFormDonation }
        },
        [
          _c(
            "form",
            {
              ref: "formPayment",
              staticClass: "donationForm",
              attrs: { method: "post" }
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Valor de Doação")]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group" }, [
                      _c("div", { staticClass: "input-group-prepend" }, [
                        _c(
                          "span",
                          {
                            staticClass: "input-group-text",
                            attrs: { id: "basic-addon1" }
                          },
                          [_vm._v("R$")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "money",
                            rawName: "v-money",
                            value: _vm.money,
                            expression: "money"
                          },
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.donationValue,
                            expression: "donationValue"
                          }
                        ],
                        staticClass: "form-control input-value",
                        attrs: {
                          required: "",
                          type: "text",
                          name: "value",
                          placeholder:
                            "Informe o valor que deseja doar para o projeto"
                        },
                        domProps: { value: _vm.donationValue },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.donationValue = $event.target.value
                          }
                        }
                      })
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-md-12" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Mensagem")]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.donationMessage,
                          expression: "donationMessage"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "message",
                        placeholder:
                          "Escreva uma mensagem para a equipe do projeto"
                      },
                      domProps: { value: _vm.donationMessage },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.donationMessage = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm.donationModalMsg
                ? _c(
                    "div",
                    {
                      staticClass:
                        "alert alert-danger alert-dismissible fade show",
                      attrs: { role: "alert" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.donationModalMsg) +
                          "\n        "
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: {
                            type: "button",
                            "data-dismiss": "alert",
                            "aria-label": "Fechar"
                          },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              $event.preventDefault()
                              return _vm.hideMsg()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabs d-none" }, [
      _c("ul", { staticClass: "filter" }, [
        _c("li", { staticClass: "active" }, [
          _c("a", { attrs: { href: "" } }, [_vm._v("Populares")])
        ]),
        _vm._v(" "),
        _c("li", [_c("a", { attrs: { href: "" } }, [_vm._v("Novos")])]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "" } }, [_vm._v("Maior arrecadação")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60dc6baa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60dc6baa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects.vue
// module id = null
// module chunks = 